import { toast } from "react-toastify";
import firebase from "../../config/firebase";
export const getSubAdmins =
  (id, onComplete = () => {}) =>
  async (dispatch) => {
    firebase
      .firestore()
      .collection("users")
      .where("school_admin_id", "==", id)
      .get()
      .then(async (query) => {
        let data = [];
        for await (let doc of query.docs) {
          data.push({ ...doc.data(), id: doc.id });
        }
        dispatch({
          type: "GET_SUB_ADMINS",
          payload: data,
        });
        onComplete();
      });
  };

export const deleteSubAdmin =
  (id, onComplete = () => {}) =>
  async (dispatch) => {
    await firebase.firestore().collection("users").doc(id).delete();
    dispatch({
      type: "DELETE_SUB_ADMIN",
      payload: id,
    });
    toast.success("Delete user successfully");
    onComplete();
  };

export const updatePermissions =
  (data, onComplete = () => {}) =>
  async (dispatch) => {
    let { id, ...newData } = data;
    await firebase.firestore().collection("users").doc(id).update(newData);
    dispatch({
      type: "UPDATE_PERMISSIONS",
      payload: data,
    });
    toast.success("Update permission successfully");
    onComplete();
  };
